export const REQUIRED_ONBOARDING = 'REQUIRED_ONBOARDING';
export const PROMOTIONS = 'PROMOTIONS';
export const PRODUCTS = 'PRODUCTS';
export const RETAIL = 'RETAIL';
export const CONTACTS = 'CONTACTS_IN_CRM';
export const MARKETING_CONTACTS = 'MARKETING_CONTACTS';
export const PURCHASE_MOTIONS = 'PURCHASE_MOTIONS';
export const PUBLIC = 'PUBLIC_META_DATA';
export const PRODUCT_INVENTORY = 'PRODUCT_INVENTORY';
export const FEATURES = 'FEATURES';
export const FEATURES_DEFAULTS = 'FEATURES_DEFAULTS';
export const FEATURES_MARKETING = 'FEATURES_MARKETING';
export const FEATURES_SALES = 'FEATURES_SALES';
export const FEATURES_SERVICE = 'FEATURES_SERVICE';
export const FEATURES_OPERATIONS = 'FEATURES_OPERATIONS';
export const FEATURES_CMS = 'FEATURES_CMS';
export const COMPANY_DETAILS = 'COMPANY_DETAILS';
export const EXPERIMENTS = 'EXPERIMENTS';